<template>
  <v-dialog v-model="openModel" max-width="600px" persistent>
    <v-card class="delete-dialog-card">
      <!-- Header with Title and Close Button -->
      <div class="delete-dialog-header">
        <span class="delete-dialog-title">{{ title || $t('delete') }}</span>
        <v-btn
          icon
          variant="text"
          size="small"
          class="delete-close-icon"
          @click="$emit('cancel')"
        >
          <v-icon size="20">mdi-close</v-icon>
        </v-btn>
      </div>

      <!-- Content -->
      <v-card-text class="delete-dialog-content">
        <slot name="message" />
      </v-card-text>

      <!-- Actions -->
      <v-card-actions class="delete-dialog-actions">
        <v-btn
          class="delete-cancel-btn"
          @click="$emit('cancel')"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          class="delete-confirm-btn"
          @click="$emit('confirm')"
        >
          <slot name="confirm-icon">
            <v-icon left size="18">mdi-trash-can-outline</v-icon>
          </slot>
          {{ $t('delete') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Shared "Custom Delete Dialog" extracted from the duplicated markup in
// views/GPTModelManagement.vue and views/DataIntegration.vue.
// Confirm/cancel logic stays in the parents; title/message/icon vary per caller.
export default {
  name: 'ConfirmDeleteDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    title: { type: String, default: '' },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  computed: {
    openModel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>

<style scoped>
/* Custom Delete Dialog Styles */
.delete-dialog-card {
  border-radius: 8px !important;
  padding: 0 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  overflow: hidden !important;
}

.delete-dialog-header {
  background: linear-gradient(180deg, #ffffff 0%, #fff1f0 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 6px 10px 24px !important;
}

.delete-dialog-title {
  font-size: 20px !important;
  font-weight: 600 !important;
  color: #dc3545 !important;
  margin: 0 !important;
}

.delete-close-icon {
  color: #6c757d !important;
  margin: 0 !important;
}

.delete-close-icon:hover {
  background-color: #f8f9fa !important;
}

.delete-dialog-content {
  font-size: 14px !important;
  color: #212529 !important;
  text-align: left !important;
  padding: 24px !important;
  line-height: 1.6 !important;
  border-bottom: 1px solid #dee2e6 !important;
  margin-bottom: 12px !important;
}

.delete-dialog-actions {
  padding: 0 24px 14px 24px !important;
  justify-content: flex-end !important;
  gap: 12px !important;
}

.delete-cancel-btn {
  background-color: white !important;
  color: #495057 !important;
  border: 1px solid #ced4da !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  box-shadow: none !important;
  height: 40px !important;
  min-width: 90px !important;
}

.delete-cancel-btn:hover {
  background-color: #f8f9fa !important;
  border-color: #adb5bd !important;
}

.delete-confirm-btn {
  background-color: #C30000 !important;
  color: white !important;
  border: none !important;
  border-radius: 11px !important;
  padding: 10px 24px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  height: 40px !important;
  min-width: 100px !important;
}

.delete-confirm-btn:hover {
  background-color: #c82333 !important;
}

.delete-confirm-btn .v-icon {
  margin-right: 6px;
}
</style>
